import { getOrgConfig } from '@api/organization';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getOrganizationIdFromStorage } from '../procurementOrders/formComponents';

/**
 * The brand's purchase-order prefixes (Settings > Order Numbering), as picker options. Shared
 * by the vendor overview and the Add Vendor form so both offer exactly the same stems.
 */
export const usePoPrefixOptions = (enabled = true): string[] => {
    const organizationId = getOrganizationIdFromStorage();
    const { data: org } = useQuery(
        ['org-config', organizationId],
        () => getOrgConfig(organizationId as string),
        { enabled: enabled && !!organizationId },
    );
    return useMemo(
        () =>
            Array.from(
                new Set(
                    (org?.documentNumbering?.PURCHASE_ORDER?.prefixes ?? [])
                        .map((entry) => entry.value?.trim())
                        .filter((value): value is string => !!value),
                ),
            ),
        [org],
    );
};
